// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3dqdn","clinicsSelect":"TableHeading_clinicsSelect__358NY"};